const sizes = {
  radius: "20px",
  dropDownWidth: "100%",
  dropDownHeight: "250px",
  dropDownItemSize: "14px",
  helperFs: "12px",
  smallFs: "18px",
  normalFs: "24px",
  bigFs: "36px",

  mainPadding: "5px",

  // border radius
  circleRadius: "50%",
  roundRadius: "25%",

  //  buttons
  bigBtnHeight: "52px",
  bigHorinzontalPadding: "10px",
};

export default sizes;
